import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  badgeMasterReflectorLabel: {
    id: 'portal.hooks.utils.badge.masterReflector.label',
    defaultMessage: 'Master Reflector',
    description: 'Badge label: Master Reflector',
  },
  badgeMasterReflectorDesc: {
    id: 'portal.hooks.utils.badge.masterReflector.desc',
    defaultMessage: 'Issued when all rating scale questions have been completed',
    description: 'Badge description: Master Reflector',
  },
  badgeToNewBeginningsLabel: {
    id: 'portal.hooks.utils.badge.toNewBeginnings.label',
    defaultMessage: 'To New Beginnings',
    description: 'Badge label: To New Beginnings',
  },
  badgeToNewBeginningsDesc: {
    id: 'portal.hooks.utils.badge.toNewBeginnings.desc',
    defaultMessage: 'Issued when you start the Leading with Character course.',
    description: 'Badge description: To New Beginnings',
  },
  badgeCoachLabel: {
    id: 'portal.hooks.utils.badge.coach.label',
    defaultMessage: 'The Coach',
    description: 'Badge label: The Coach',
  },
  badgeCoachDesc: {
    id: 'portal.hooks.utils.badge.coach.desc',
    defaultMessage: 'Issued when you complete the Effective Questions quiz in the Leading Together (Love) module.',
    description: 'Badge description: The Coach',
  },
  badgeWatcherLabel: {
    id: 'portal.hooks.utils.badge.watcher.label',
    defaultMessage: 'The Watcher',
    description: 'Badge label: The Watcher',
  },
  badgeWatcherDesc: {
    id: 'portal.hooks.utils.badge.watcher.desc',
    defaultMessage: 'Issued when you have watched 100% of the videos in the course.',
    description: 'Badge description: The Watcher',
  },
  badgeQuizmasterLabel: {
    id: 'portal.hooks.utils.badge.quizmaster.label',
    defaultMessage: 'The Quizmaster',
    description: 'Badge label: The Quizmaster',
  },
  badgeQuizmasterDesc: {
    id: 'portal.hooks.utils.badge.quizmaster.desc',
    defaultMessage: 'Issued once you have completed all quizzes across the course.',
    description: 'Badge description: The Quizmaster',
  },
  badgeHotspotterLabel: {
    id: 'portal.hooks.utils.badge.hotspotter.label',
    defaultMessage: 'The Hotspotter',
    description: 'Badge label: The Hotspotter',
  },
  badgeHotspotterDesc: {
    id: 'portal.hooks.utils.badge.hotspotter.desc',
    defaultMessage: 'Issued when you have read all the hotspots within the course.',
    description: 'Badge description: The Hotspotter',
  },
  unearnedCertificateTooltip: {
    id: 'portal.components.achievements.tooltip.unearnedCertificate',
    defaultMessage: 'Complete {course} to earn this certificate',
    description: 'Tooltip shown on greyed-out certificates that the learner has not yet earned',
  },
});

export default messages;
